import { isString } from './nodash';
export default function getOptionProperty(option, key) {
  if (isString(option)) {
    return undefined;
  }

  return option[key];
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-bootstrap-typeahead/es/utils/getOptionProperty.js
// module id = 240
// module chunks = 31